// 字典工具模块
import axios from '@/utils/request'

// 全局字典单例对象
const globalDic = {
  D_Role: [],
  D_Port: [],
  D_PersonType: []
  // 可扩展更多字典
}

export function fetchDic(dicName) {
  return axios.post('/api/Dic/QueryDicInfo', { dicName });
}

export async function fetchMultiDic(dicNames = []) {
  const result = {};
  await Promise.all(dicNames.map(async dicName => {
    const res = await fetchDic(dicName);
    if (res && res.data && res.data.success) {
      // 过滤掉 code 为 -99 的数据（初始值）
      const filteredData = (res.data.data || []).filter(item => item.code !== '-99');
      result[dicName] = filteredData;
      globalDic[dicName] = filteredData;
    } else {
      result[dicName] = [];
      globalDic[dicName] = [];
    }
  }));
  return result;
}

export default globalDic; 
